import img1 from "@/assets/li_1.jpeg";
import img2 from "@/assets/li_2.jpeg";
import img3 from "@/assets/li_3.jpeg";
import img4 from "@/assets/li_4.jpeg";
import img5 from "@/assets/li_5.jpeg";
import img6 from "@/assets/li_6.jpeg";

const list = [
  {
    title: "提供“一站式”的供应链解决方案",
    en: "Provide “One-Stop” supply chain solutions",
    img: img1,
    desc: "海上的交通运输，如散杂货运输、集装箱运输等港到港的海上运输。"
  },
  {
    title: "国际海陆空运输",
    en: "Air,Ocean,Truck,Train Services",
    img: img2,
    desc: "空运以其迅捷，安全。准时的超高效率赢得了相当大的市场。"
  },
  {
    title: "国内码头线拖车及报关",
    en: "Inland truck and Do custom clearance ",
    img: img5,
    desc: "关联生产、流通、消费、是不可替代的日常生活基础服务。"
  },
  {
    title: "中港间拖车",
    en: "Truck between Hongkong and China",
    img: img4,
    desc: "精益求精做好物流中间环节，尽心尽力服务客户。"
  },
  {
    title: "国际快递一件代发",
    en: "Cross-border trade One piece on consignment",
    img: img3,
    desc: "解决物流流通过程中的报关报税问题为企业更好地服务于全球。"
  },
  {
    title: "跨境电商海外仓一站式服务",
    en: "One-stop service for overseas warehouses in cross-border e-commerce",
    img: img6,
    desc: "保险人对由自然灾害和意外事故造成的货物损失负责赔偿责任的保险。"
  }
];

export { list };



// WEBPACK FOOTER //
// ./src/utils/index.js